import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import { Link } from "react-router-dom";

import { Logo } from "../Logo";
import "./Footer.scss";

export default class Footer extends React.Component {
  state = {};
  render() {
    return (
      <div className="footerContainer">
        <Container>
          {/* <Row>
            <Col className="listCol">
              <h5>Admin</h5>
              <Link to="/admin">Login Page</Link>
            </Col>
          </Row> */}
          <Row>
            <Col md={3}>
              <Logo className="footerLogo" />
            </Col>
            <Col md={9} className="linkCol">
              <div className="footerLinks">
                <a href="mailto:getsafebox@gmail.com">getsafebox@gmail.com</a>
                <span className="separator">—</span>
                <span>Copyright © 2019 SafeBox, Inc. All rights reserved.</span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
